/**
 * @generated SignedSource<<f054eaf7965c662f2d8078f08d80f7be>>
 * @relayHash ae7313765fa872cbd01d104dd516c514
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ae7313765fa872cbd01d104dd516c514

import { ConcreteRequest } from 'relay-runtime';
export type ReportAnIssueInput = {
  actionsBeforeIssue: string;
  consoleLogJson: string;
  currentLocation: string;
  faroInsightJson: string;
  fetchedUserInfoJson: string;
  graphQlLogJson: string;
  injectedSofiaEnvironmentJson: string;
  issueDescription: string;
  latestFrontEndErrorsJson: string;
  parsedUserInfoJson: string;
  releaseInfoJson: string;
  userAgent: string;
  windowSize?: BrowserWindowSizeInput | null;
};
export type BrowserWindowSizeInput = {
  innerHeight: number;
  innerWidth: number;
};
export type useReportAnIssueMutation$variables = {
  input: ReportAnIssueInput;
};
export type useReportAnIssueMutation$data = {
  readonly reportAnIssue: {
    readonly boolean: boolean | null;
  };
};
export type useReportAnIssueMutation = {
  response: useReportAnIssueMutation$data;
  variables: useReportAnIssueMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ReportAnIssuePayload",
    "kind": "LinkedField",
    "name": "reportAnIssue",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "boolean",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useReportAnIssueMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useReportAnIssueMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "ae7313765fa872cbd01d104dd516c514",
    "metadata": {},
    "name": "useReportAnIssueMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "075964bfead4c23de1363413c614030b";

export default node;
